export const PUSH_STATUS = Object.freeze({
  IDLE: "idle",
  CHECKING: "checking",
  UNSUPPORTED: "unsupported",
  INSTALL_REQUIRED: "install-required",
  PROMPT: "prompt",
  ENABLING: "enabling",
  ENABLED: "enabled",
  BLOCKED: "blocked",
  ERROR: "error",
  DISABLED: "disabled",
});

export function detectPushPlatform({ userAgent = "", maxTouchPoints = 0 } = {}) {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "ios";
  if (/Macintosh/i.test(userAgent) && Number(maxTouchPoints) > 1) return "ios";
  if (/Android/i.test(userAgent)) return "android";
  return "web";
}

export function isStandaloneWebApp({ displayModeStandalone = false, navigatorStandalone = false } = {}) {
  return Boolean(displayModeStandalone || navigatorStandalone);
}

export function resolvePushStatus({
  disabled = false,
  signedIn = false,
  hasVapidKey = false,
  hasNotificationApi = false,
  hasServiceWorker = false,
  supported = false,
  platform = "web",
  installed = false,
  permission = "default",
} = {}) {
  if (disabled) return PUSH_STATUS.DISABLED;
  if (!signedIn || !hasVapidKey) return PUSH_STATUS.IDLE;
  if (!hasNotificationApi || !hasServiceWorker || !supported) return PUSH_STATUS.UNSUPPORTED;
  if (platform === "ios" && !installed) return PUSH_STATUS.INSTALL_REQUIRED;
  if (permission === "denied") return PUSH_STATUS.BLOCKED;
  if (permission === "granted") return PUSH_STATUS.ENABLED;
  return PUSH_STATUS.PROMPT;
}
